import {NumberUtil} from "base/utilities";
import {SectionCard, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const AglomeracionInventarioTanquesSection = ({aglomeracion}) => {
    return (
        <SectionCard title="Tanques">
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Totais:"
                        value={NumberUtil.formatInteger(aglomeracion.stats.tanques)}
                        tooltipText="Número de tanques de tormenta instalados na rede"
                    />
                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default AglomeracionInventarioTanquesSection;
